<template>
  <div class="content">
    <h1>登录页</h1>
  </div>
</template>

<script>
export default {
  title: '登录',
  data () {
    return {
      data: '登录'
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    height: 100%;
    width: 100%;
  }
</style>
